import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import "../../css/CRUDModal.css";

const WalletBalanceModal = ({
  show,
  handleClose,
  walletDetail,
  walletTitle,
  balance: balanceProp,
}) => {
  const handleBack = () => {
    handleClose();
  };

  const initialTabMap = {
    "Main Wallet": "Main Balance",
    "SMS Balance": "SMS Balance",
    "RCS Balance": "RCS Balance",
    "WA Balance": "WA Balance",
  };

  const userRole = sessionStorage.getItem("userRole");
  const isCust = userRole === "CUST";
  const isPartner = userRole === "PARTNER";

  const [activeTab, setActiveTab] = useState("Main Balance");
  const [isMsgCapacityExpanded, setIsMsgCapacityExpanded] = useState(false);

  useEffect(() => {
    if (show) {
      setActiveTab("Main Balance");
      setIsMsgCapacityExpanded(false);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [show, isCust]);

  const reduxBalance = useSelector((state) => state.balance.balance);
  const { user } = useSelector((state) => state.auth);

  const balance = balanceProp || reduxBalance;

  const waMarketingRate = balance?.waMarketingRate || user?.data?.waMarketingRate || 110;
  const waUtilityRate = balance?.waUtilityRate || user?.data?.waUtilityRate || 110;
  const waAuthenticationRate = balance?.waAuthenticationRate || user?.data?.waAuthenticationRate || 870;


  const formatCurrency = (val) => {
    return Number(val || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const formatCount = (val) => {
    if (val === undefined || val === null || val === "" || val === "N/A") return "N/A";
    const num = Number(val);
    if (isNaN(num)) return "N/A";
    return num.toLocaleString("en-IN");
  };

  const mainWalletValue = balance?.mainBalanceAmountList && balance?.mainBalanceAmountList.length > 0
    ? balance.mainBalanceAmountList.reduce((acc, item) => acc + Number(Object.values(item)[0] || 0), 0)
    : 0;

  const unclearWalletValue = Number(balance?.unclearBalance || 0);

  const partnerWalletValue = Number(balance?.partnerBalance || 0);

  const partnerUnclearWalletValue = Number(balance?.partnerUnclearBalance || 0);

  const getTabDetails = () => {
    switch (activeTab) {
      case "Main Balance":
        return balance?.mainBalanceAmountList || [];
      case "SMS Balance":
        return balance?.smsBalanceList || [];
      case "RCS Balance":
        return balance?.rcsBalanceCountList || [];
      case "WA Balance":
        return balance?.waBalanceCountList || [];
      case "Partner Balance":
        return balance?.partnerBalanceList || [];
      default:
        return [];
    }
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document" style={{ margin: "0 auto", display: "flex", justifyContent: "center", alignItems: "center", transform: "translateY(-4vh)" }}>
            <div
              className="modal-content"
              style={{
                width: "95vw",
                maxWidth: "720px",
                height: "615px",
                maxHeight: "95vh",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              {(
                  <div style={{position: "relative", padding: "10px 10px 5px 10px", flexShrink: 0}}
                       className="font-sans text-left">
                    <h2 className="text-xl font-bold text-slate-800 leading-tight">Balance Details</h2>
                    <p className="text-xs text-slate-400 mt-1">View and manage your wallet and service balances</p>
                    <button
                        type="button"
                        onClick={handleClose}
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "10px",
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                          border: "1px solid #dee2e6",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#999",
                          cursor: "pointer",
                          background: "#fff"
                        }}
                        className="hover:text-slate-600 hover:border-slate-300 transition-colors"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"/>
                      </svg>
                    </button>
                  </div>
              )}
              <form>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                  }}
                >
                  {(
                      <div
                          className="border border-slate-200 rounded-lg flex items-center overflow-hidden bg-white mt-1 mb-2.5 w-full">
                        {["Main Balance", "SMS Balance", "RCS Balance", ...(isPartner ? ["Partner Balance"] : [])].map((tab, index) => {
                          const isActive = activeTab === tab;
                          const label = tab === "Main Balance" ? "Main Wallet" : tab === "SMS Balance" ? "SMS" : tab === "RCS Balance" ? "RCS" : "Partner";
                          return (
                              <React.Fragment key={tab}>
                                {index > 0 && <div className="h-5 w-[1px] bg-slate-200 flex-shrink-0"/>}
                                <button
                                    type="button"
                                    onClick={() => setActiveTab(tab)}
                                    className={`flex-1 flex items-center justify-center gap-2 py-2.5 text-[11px] font-bold transition-colors border-b-2 border-t-0 border-l-0 border-r-0 cursor-pointer ${isActive
                                        ? "bg-[#f0fafd]/40 text-[#00b6ce] border-b-[#00b6ce]"
                                        : "text-slate-500 hover:text-slate-700 border-b-transparent bg-transparent"
                                    }`}
                                >
                                  {tab === "Main Balance" && (
                                      <svg className={`w-3.5 h-3.5 ${isActive ? "text-[#00b6ce]" : "text-slate-600"}`}
                                           fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                                        <rect x="3" y="4" width="18" height="16" rx="2"/>
                                        <path d="M16 8h4v8h-4z"/>
                                      </svg>
                                  )}
                                  {tab === "SMS Balance" && (
                                      <svg className={`w-3.5 h-3.5 ${isActive ? "text-[#00b6ce]" : "text-slate-600"}`}
                                           fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                                      </svg>
                                  )}
                                  {tab === "RCS Balance" && (
                                      <svg className={`w-3.5 h-3.5 ${isActive ? "text-[#00b6ce]" : "text-slate-600"}`}
                                           fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                                        <rect x="5" y="2" width="14" height="20" rx="2"/>
                                        <path d="M12 18h.01"/>
                                      </svg>
                                  )}
                                  {tab === "WA Balance" && (
                                      <svg className={`w-3.5 h-3.5 ${isActive ? "text-[#00b6ce]" : "text-slate-600"}`}
                                           fill="currentColor" viewBox="0 0 24 24">
                                        <path
                                            d="M17.472 14.382c-.022-.08-.078-.135-.138-.16l-1.996-.98c-.147-.073-.322-.016-.405.127l-.683.82c-.084.1-.213.14-.333.102-1.206-.38-2.16-1.33-2.54-2.54-.038-.12 0-.25.102-.333l.82-.68c.143-.083.2-.258.127-.405l-.98-1.996c-.05-.098-.16-.14-.268-.138l-.66.077c-.37.043-.65.234-.77.585-.36 1.05-.2 2.37.58 3.52.88 1.3 2.2 2.62 3.52 3.5.87.58 1.9.89 2.92.59.35-.1.54-.38.58-.75l.077-.66z"/>
                                        <path
                                            d="M12 2C6.477 2 2 6.477 2 12c0 1.886.52 3.653 1.42 5.17L2.05 22l5.02-1.33C8.52 21.49 10.21 22 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18c-1.634 0-3.167-.44-4.502-1.21l-.323-.19-2.98.79.8-2.906-.207-.33C3.99 14.83 3.5 13.166 3.5 12c0-4.687 3.813-8.5 8.5-8.5s8.5 3.813 8.5 8.5-3.813 8.5-8.5 8.5z"/>
                                      </svg>
                                  )}
                                  {tab === "Partner Balance" && (
                                      <svg className={`w-3.5 h-3.5 ${isActive ? "text-[#00b6ce]" : "text-slate-600"}`}
                                           fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                                        <circle cx="9" cy="7" r="4"/>
                                        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                                      </svg>
                                  )}
                                  {label}
                                </button>
                              </React.Fragment>
                          );
                        })}
                      </div>
                  )}

                  {/* Tab Contents Scroll Container */}
                  <div style={{ height: "470px", overflowY: "auto", paddingRight: "4px", paddingBottom: "20px" }}>
                    {activeTab === "Unclear Balance" && (
                      <div style={{ padding: "12px 0", textAlign: "center" }}>
                        <span style={{ fontSize: "13px", color: "#666", display: "block", marginBottom: "4px" }}>Unclear Balance</span>
                        <span style={{ fontSize: "24px", fontWeight: "700", color: "var(--primary-color)" }}>
                          ₹ {balance?.unclearBalance
                            ? Number(balance.unclearBalance).toFixed(2).length > 9
                              ? Number(balance.unclearBalance).toFixed(2).slice(0, 9) + "..."
                              : Number(balance.unclearBalance).toFixed(2)
                            : "0.00"}
                        </span>
                      </div>
                    )}

                    {activeTab !== "Unclear Balance" && (
                      <>
                        {activeTab === "Main Balance" ? (
                          <div className="space-y-3.5 w-full font-sans text-left">
                            {/* Side-by-side summary cards (Compact) */}
                            <div className="grid grid-cols-2 gap-3.5 mt-3.5">
                              {/* Main Wallet Card */}
                              <div className="bg-white border border-[#e2e8f0] border-l-[4px] border-l-[#00b6ce] rounded-xl p-4 shadow-[0_4px_16px_rgba(0,182,206,0.06)] flex items-start gap-3">
                                <div className="w-12 h-12 rounded-full bg-[#dff5f7] text-[#00b6ce] flex items-center justify-center flex-shrink-0">
                                  <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                    <rect x="3" y="4" width="18" height="16" rx="2" />
                                    <path d="M16 8h4v8h-4z" />
                                  </svg>
                                </div>
                                <div className="flex flex-col flex-1">
                                  <span className="text-xs font-extrabold text-slate-800 leading-none">Main Wallet</span>
                                  <span className="text-xl font-black text-slate-900 mt-2 block">
                                    ₹{formatCurrency(mainWalletValue)}
                                  </span>
                                  <span className="text-[10px] text-slate-400 font-bold mt-1 block">Available Balance</span>
                                  <span className="px-3 py-1 rounded-lg text-[8px] font-extrabold bg-[#d2ebd9] text-[#1e4c27] flex items-center gap-1.5 mt-3 w-full">
                                    <span className="w-2.5 h-2.5 rounded-full bg-[#10b981] block"></span>
                                    Ready to use
                                  </span>
                                </div>
                              </div>

                              {/* Unclear Balance Card */}
                              <div className="bg-white border border-[#e2e8f0] border-l-[4px] border-l-[#ff9f43] rounded-xl p-4 shadow-[0_4px_16px_rgba(255,159,67,0.06)] flex items-start gap-3">
                                <div className="w-12 h-12 rounded-full bg-[#fdf0e6] text-[#ff9f43] flex items-center justify-center flex-shrink-0">
                                  <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                    <rect x="3" y="4" width="18" height="16" rx="2" />
                                    <path d="M16 8h4v8h-4z" />
                                  </svg>
                                </div>
                                <div className="flex flex-col flex-1">
                                  <span className="text-xs font-extrabold text-slate-800 leading-none">Unclear Balance</span>
                                  <span className="text-xl font-black text-slate-900 mt-2 block">
                                    ₹{formatCurrency(unclearWalletValue)}
                                  </span>
                                  <span className="text-[10px] text-slate-400 font-bold mt-1 block">Pending Clearance</span>
                                  <span className="px-3 py-1 rounded-lg text-[8px] font-extrabold bg-[#fde8d7] text-[#854d0e] flex items-center gap-1.5 mt-3 w-full">
                                    <span className="w-2.5 h-2.5 rounded-full bg-[#ff9f43] block"></span>
                                    Waiting Approval from Accounts Team
                                  </span>
                                </div>
                              </div>
                            </div>

                            {/* Bank Summary Table for Admin */}
                            {!isCust && (
                              <div className="bg-[#eefbfc] border border-[#d0f0f4] rounded-2xl p-4 mt-4 w-full">
                                {/* Table Header Row */}
                                <div className="bg-white rounded-lg p-2.5 flex items-center justify-between shadow-sm px-4">
                                  <span className="text-xs font-bold text-slate-700">Name</span>
                                  <span className="text-xs font-bold text-slate-700">Amount</span>
                                </div>
                                {/* Table Data Rows */}
                                <div className="mt-2 divide-y divide-[#d0f0f4]/30 px-2">
                                  {getTabDetails() && getTabDetails().length > 0 ? (
                                    getTabDetails().map((item, index) => {
                                      const [label, value] = Object.entries(item)[0];
                                      return (
                                        <div key={index} className="py-2.5 flex items-center justify-between text-xs text-slate-600 font-medium">
                                          <span>{label}</span>
                                          <span className="font-extrabold text-slate-700">₹{formatCurrency(value)}</span>
                                        </div>
                                      );
                                    })
                                  ) : (
                                    <div className="py-4 text-center text-xs text-slate-400 italic">No details available.</div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        ) : activeTab === "SMS Balance" ? (
                          <div className="space-y-4 w-full font-sans text-left">
                            {/* Header with Active badge */}
                            <div className="flex items-center justify-between mt-1">
                              <div className="flex items-center gap-2.5">
                                <div className="w-9 h-9 rounded-full bg-[#00b6ce] text-white flex items-center justify-center">
                                  <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                                  </svg>
                                </div>
                                <span className="text-[17px] font-black text-slate-800">SMS Balance Details</span>
                              </div>
                              <span className="px-2.5 py-1 rounded-full text-[10px] font-extrabold bg-[#d2ebd9] text-[#1e4c27] flex items-center gap-1">
                                <span className="w-1.5 h-1.5 rounded-full bg-[#10b981] block"></span>
                                Active
                              </span>
                            </div>

                            {/* Subtitle details */}
                            <div className="mt-3">
                              <span className="text-[11px] font-bold text-[#00b6ce] uppercase tracking-wider block">Main Wallet</span>
                              <p className="text-[11px] text-slate-500 mt-1 leading-normal">
                                This is your approved wallet recharge amount available for sending SMS message.
                              </p>
                            </div>

                            {/* Three statistics cards/icons */}
                            <div className="grid grid-cols-3 gap-3.5 mt-4">
                              {/* SMS Balance */}
                              <div className="flex flex-col items-start gap-1">
                                <div className="w-8 h-8 rounded-full bg-[#35a5f1] text-white flex items-center justify-center">
                                  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M3 20h18" />
                                    <rect x="6" y="13" width="2.5" height="7" rx="0.5" />
                                    <rect x="10.5" y="9" width="2.5" height="11" rx="0.5" />
                                    <rect x="15" y="5" width="2.5" height="15" rx="0.5" />
                                  </svg>
                                </div>
                                <span className="text-[10px] text-slate-400 font-bold mt-2">SMS Balance</span>
                                <span className="text-base font-extrabold text-[#12B5D0]">
                                  {formatCount(balance?.smsBalanceCount !== undefined ? balance.smsBalanceCount : (balance?.smsBalanceList ? balance.smsBalanceList.reduce((acc, item) => acc + Number(Object.values(item)[0] || 0), 0) : null))}
                                </span>
                                <span className="text-[9px] text-slate-400 font-medium">Available Credits</span>
                              </div>

                              {/* SMS Pending Delivery */}
                              <div className="flex flex-col items-start gap-1">
                                <div className="w-8 h-8 rounded-full bg-[#ff9800] text-white flex items-center justify-center">
                                  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M12 13v6m0 0l-2.5-2.5M12 19l2.5-2.5" />
                                    <path d="M20.88 18.09A5 5 0 0018 9h-1.26A8 8 0 103 16.29" />
                                  </svg>
                                </div>
                                <span className="text-[10px] text-slate-400 font-bold mt-2">SMS Pending Delivery</span>
                                <span className="text-base font-extrabold text-[#fb8c00]">
                                  {formatCount(balance?.smsPendingDelivery)}
                                </span>
                                <span className="text-[9px] text-slate-400 font-medium">Credits on hold</span>
                              </div>

                              {/* SMS Delivered Credits */}
                              <div className="flex flex-col items-start gap-1">
                                <div className="w-8 h-8 rounded-full bg-[#4caf50] text-white flex items-center justify-center">
                                  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                                    <polyline points="15 3 21 3 21 9" />
                                    <line x1="10" y1="14" x2="21" y2="3" />
                                  </svg>
                                </div>
                                <span className="text-[10px] text-slate-400 font-bold mt-2">SMS Delivered Credits</span>
                                <span className="text-base font-extrabold text-[#43a047]">
                                  {formatCount(balance?.smsDeliveredCredits)}
                                </span>
                                <span className="text-[9px] text-slate-400 font-medium">Total Delivered</span>
                              </div>
                            </div>

                            {/* Bottom Table Card */}
                            <div className="bg-[#eefbfc] border border-[#d0f0f4] rounded-2xl p-4 mt-4 w-full">
                              {/* Table Header Row */}
                              <div className="bg-white rounded-lg p-2.5 flex items-center justify-between shadow-sm px-4">
                                <span className="text-xs font-bold text-slate-700">Name</span>
                                <span className="text-xs font-bold text-slate-700">Amount</span>
                              </div>
                              {/* Table Data Rows */}
                              <div className="mt-2 divide-y divide-[#d0f0f4]/30 px-2">
                                {getTabDetails() && getTabDetails().length > 0 ? (
                                  getTabDetails().map((item, index) => {
                                    const [label, value] = Object.entries(item)[0];
                                    return (
                                      <div key={index} className="py-2.5 flex items-center justify-between text-xs text-slate-600 font-medium">
                                        <span>{label}</span>
                                        <span className="font-extrabold text-slate-700">{value ?? 0} Qty</span>
                                      </div>
                                    );
                                  })
                                ) : (
                                  <div className="py-4 text-center text-xs text-slate-400 italic">No details available.</div>
                                )}
                              </div>
                            </div>
                          </div>
                        ) : activeTab === "RCS Balance" ? (
                          <div className="space-y-4 w-full font-sans text-left">
                            {/* Header with Active badge */}
                            <div className="flex items-center justify-between mt-1">
                              <div className="flex items-center gap-2.5">
                                <div className="w-9 h-9 rounded-full bg-[#00b6ce] text-white flex items-center justify-center">
                                  <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                                    <rect x="5" y="2" width="14" height="20" rx="2" />
                                    <path d="M12 18h.01" />
                                  </svg>
                                </div>
                                <span className="text-[17px] font-black text-slate-800">RCS Balance Details</span>
                              </div>
                              <span className="px-2.5 py-1 rounded-full text-[10px] font-extrabold bg-[#d2ebd9] text-[#1e4c27] flex items-center gap-1">
                                <span className="w-1.5 h-1.5 rounded-full bg-[#10b981] block"></span>
                                Active
                              </span>
                            </div>

                            {/* Subtitle details */}
                            <div className="mt-3">
                              <span className="text-[11px] font-bold text-[#00b6ce] uppercase tracking-wider block">Main Wallet</span>
                              <p className="text-[11px] text-slate-500 mt-1 leading-normal">
                                This is your approved wallet recharge amount available for sending RCS message.
                              </p>
                            </div>

                            {/* Three statistics cards/icons */}
                            <div className="grid grid-cols-3 gap-3.5 mt-4">
                              {/* RCS Balance */}
                              <div className="flex flex-col items-start gap-1">
                                <div className="w-8 h-8 rounded-full bg-[#35a5f1] text-white flex items-center justify-center">
                                  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M3 20h18" />
                                    <rect x="6" y="13" width="2.5" height="7" rx="0.5" />
                                    <rect x="10.5" y="9" width="2.5" height="11" rx="0.5" />
                                    <rect x="15" y="5" width="2.5" height="15" rx="0.5" />
                                  </svg>
                                </div>
                                <span className="text-[10px] text-slate-400 font-bold mt-2">RCS Balance</span>
                                <span className="text-base font-extrabold text-[#12B5D0]">
                                  {formatCount(balance?.rcsBalanceCount !== undefined ? balance.rcsBalanceCount : (balance?.rcsBalanceCountList ? balance.rcsBalanceCountList.reduce((acc, item) => acc + Number(Object.values(item)[0] || 0), 0) : null))}
                                </span>
                                <span className="text-[9px] text-slate-400 font-medium">Available Credits</span>
                              </div>

                              {/* RCS Pending Delivery */}
                              <div className="flex flex-col items-start gap-1">
                                <div className="w-8 h-8 rounded-full bg-[#ff9800] text-white flex items-center justify-center">
                                  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M12 13v6m0 0l-2.5-2.5M12 19l2.5-2.5" />
                                    <path d="M20.88 18.09A5 5 0 0018 9h-1.26A8 8 0 103 16.29" />
                                  </svg>
                                </div>
                                <span className="text-[10px] text-slate-400 font-bold mt-2">RCS Pending Delivery</span>
                                <span className="text-base font-extrabold text-[#fb8c00]">
                                  {formatCount(balance?.rcsPendingDelivery)}
                                </span>
                                <span className="text-[9px] text-slate-400 font-medium">Credits on hold</span>
                              </div>

                              {/* RCS Delivered Credits */}
                              <div className="flex flex-col items-start gap-1">
                                <div className="w-8 h-8 rounded-full bg-[#4caf50] text-white flex items-center justify-center">
                                  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                                    <polyline points="15 3 21 3 21 9" />
                                    <line x1="10" y1="14" x2="21" y2="3" />
                                  </svg>
                                </div>
                                <span className="text-[10px] text-slate-400 font-bold mt-2">RCS Delivered Credits</span>
                                <span className="text-base font-extrabold text-[#43a047]">
                                  {formatCount(balance?.rcsDeliveredCredits)}
                                </span>
                                <span className="text-[9px] text-slate-400 font-medium">Total Delivered</span>
                              </div>
                            </div>

                            {/* Bottom Table Card */}
                            <div className="bg-[#eefbfc] border border-[#d0f0f4] rounded-2xl p-4 mt-4 w-full">
                              {/* Table Header Row */}
                              <div className="bg-white rounded-lg p-2.5 flex items-center justify-between shadow-sm px-4">
                                <span className="text-xs font-bold text-slate-700">Name</span>
                                <span className="text-xs font-bold text-slate-700">Amount</span>
                              </div>
                              {/* Table Data Rows */}
                              <div className="mt-2 divide-y divide-[#d0f0f4]/30 px-2">
                                {getTabDetails() && getTabDetails().length > 0 ? (
                                  getTabDetails().map((item, index) => {
                                    const [label, value] = Object.entries(item)[0];
                                    return (
                                      <div key={index} className="py-2.5 flex items-center justify-between text-xs text-slate-600 font-medium">
                                        <span>{label}</span>
                                        <span className="font-extrabold text-slate-700">{value ?? 0} Qty</span>
                                      </div>
                                    );
                                  })
                                ) : (
                                  <div className="py-4 text-center text-xs text-slate-400 italic">No details available.</div>
                                )}
                              </div>
                            </div>
                          </div>
                        ) : activeTab === "Partner Balance" ? (
                            <div className="space-y-3.5 w-full font-sans text-left">
                              {/* Side-by-side summary cards (Compact) */}
                              <div className="grid grid-cols-2 gap-3.5 mt-3.5">
                                {/* Partner Wallet Card */}
                                <div
                                    className="bg-white border border-[#e2e8f0] border-l-[4px] border-l-[#00b6ce] rounded-xl p-4 shadow-[0_4px_16px_rgba(0,182,206,0.06)] flex items-start gap-3">
                                  <div
                                      className="w-12 h-12 rounded-full bg-[#dff5f7] text-[#00b6ce] flex items-center justify-center flex-shrink-0">
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2"
                                         viewBox="0 0 24 24">
                                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                                      <circle cx="9" cy="7" r="4"/>
                                      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                                      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                                    </svg>
                                  </div>
                                  <div className="flex flex-col flex-1">
                                    <span
                                        className="text-xs font-extrabold text-slate-800 leading-none">Partner Wallet</span>
                                    <span className="text-xl font-black text-slate-900 mt-2 block">
                                    ₹{formatCurrency(partnerWalletValue)}
                                  </span>
                                    <span
                                        className="text-[10px] text-slate-400 font-bold mt-1 block">Available Balance</span>
                                    <span
                                        className="px-3 py-1 rounded-lg text-[8px] font-extrabold bg-[#d2ebd9] text-[#1e4c27] flex items-center gap-1.5 mt-3 w-full">
                                    <span className="w-2.5 h-2.5 rounded-full bg-[#10b981] block"></span>
                                    Ready to use
                                  </span>
                                  </div>
                                </div>

                                {/* Partner Unclear Balance Card */}
                                <div
                                    className="bg-white border border-[#e2e8f0] border-l-[4px] border-l-[#ff9f43] rounded-xl p-4 shadow-[0_4px_16px_rgba(255,159,67,0.06)] flex items-start gap-3">
                                  <div
                                      className="w-12 h-12 rounded-full bg-[#fdf0e6] text-[#ff9f43] flex items-center justify-center flex-shrink-0">
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2"
                                         viewBox="0 0 24 24">
                                      <rect x="3" y="4" width="18" height="16" rx="2"/>
                                      <path d="M16 8h4v8h-4z"/>
                                    </svg>
                                  </div>
                                  <div className="flex flex-col flex-1">
                                    <span
                                        className="text-xs font-extrabold text-slate-800 leading-none">Unclear Balance</span>
                                    <span className="text-xl font-black text-slate-900 mt-2 block">
                                    ₹{formatCurrency(partnerUnclearWalletValue)}
                                  </span>
                                    <span
                                        className="text-[10px] text-slate-400 font-bold mt-1 block">Pending Clearance</span>
                                    <span
                                        className="px-3 py-1 rounded-lg text-[8px] font-extrabold bg-[#fde8d7] text-[#854d0e] flex items-center gap-1.5 mt-3 w-full">
                                    <span className="w-2.5 h-2.5 rounded-full bg-[#ff9f43] block"></span>
                                    Waiting Approval from Accounts Team
                                  </span>
                                  </div>
                                </div>
                              </div>

                              <div className="bg-[#eefbfc] border border-[#d0f0f4] rounded-2xl p-4 mt-4 w-full">
                                {/* Table Header Row */}
                                <div
                                    className="bg-white rounded-lg p-2.5 flex items-center justify-between shadow-sm px-4">
                                  <span className="text-xs font-bold text-slate-700">Name</span>
                                  <span className="text-xs font-bold text-slate-700">Amount</span>
                                </div>
                                {/* Table Data Rows */}
                                <div className="mt-2 divide-y divide-[#d0f0f4]/30 px-2">
                                  {getTabDetails() && getTabDetails().length > 0 ? (
                                      getTabDetails().map((item, index) => {
                                        const [label, value] = Object.entries(item)[0];
                                        return (
                                            <div key={index}
                                                 className="py-2.5 flex items-center justify-between text-xs text-slate-600 font-medium">
                                              <span>{label}</span>
                                              <span
                                                  className="font-extrabold text-slate-700">₹{formatCurrency(value)}</span>
                                            </div>
                                        );
                                      })
                                  ) : (
                                      <div className="py-4 text-center text-xs text-slate-400 italic">No details
                                        available.</div>
                                  )}
                                </div>
                              </div>
                            </div>
                        ) : null}
                      </>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WalletBalanceModal;
